<template>
  <el-dialog
    :visible.sync="dialogVisible"
    :before-close="closeDialogImport"
    :title="dialogImportTitle"
    class="abow_dialog h300_dialog"
    append-to-body
  >
    <div
      v-loading="loading"
      :loading="loading"
      :element-loading-text="$t('detailPage.loading')"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
    >
      <el-form
        ref="importForm"
        :model="importForm"
        :rules="importFormRules"
        class="add-edit-view-form"
        @submit.native.prevent
      >
        <div class="modal-row-box">
          <el-row :gutter="10">
            <el-col :span="6">
              <el-form-item
                label="年份"
                prop="year"
              >
                <el-select
                  v-model="importForm.year"
                  filterable
                  placeholder="请选择年份"
                  style="width:100%"
                >
                  <el-option
                    v-for="item in yearOptions"
                    :key="item.data"
                    :label="item.label"
                    :value="item.data"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item
                label="月份"
                prop="month"
              >
                <el-select
                  v-model="importForm.month"
                  filterable
                  placeholder="请选择月份"
                  style="width:100%"
                >
                  <el-option
                    v-for="item in monthOptions"
                    :key="item.data"
                    :label="item.label"
                    :value="item.data"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item
                label="省区"
                prop="provinceId"
              >
                <el-select
                  v-model="importForm.provinceId"
                  filterable
                  placeholder="请选择省区"
                  style="width:100%"
                  @change="changeProvinceFun"
                >
                  <el-option
                    v-for="item in provinceOptions"
                    :key="item.data"
                    :label="item.label"
                    :value="item.data"
                  />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-form>
      <el-upload
        ref="upload"
        class="upload-demo"
        :with-credentials="true"
        :action="action"
        :data="importForm"
        :before-upload="beforeTemplateImportUpload"
        :on-error="handleError"
        :on-exceed="handleExceed"
        :on-success="handleSuccess"
        :headers="{'X-Token': getToken()}"
        name="upload-file"
        accept=".xls,.xlsx"
        :limit="1"
        :file-list="fileList"
        :auto-upload="false"
      >
        <el-button
          slot="trigger"
          size="small"
          type="primary"
        >
          {{ '选择文件' }}
        </el-button>
        <el-button
          style="margin-left: 10px;"
          size="small"
          type="success"
          @click="submitUpload"
        >
          {{ '开始导入' }}
        </el-button>
        <div
          slot="tip"
          class="el-upload__tip"
        >
          {{ '提示：一次最多可以上传1个文件' }}
        </div>
      </el-upload>
    </div>
    <div
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click="closeDialogImport">
        {{ '关闭' }}
      </el-button>
    </div>
  </el-dialog>
</template>
<script>
import { loadAreaDataApi } from '@/api/area'
import { getToken } from "@/utils/auth"
export default {
  props: {
    dialogImportTitle: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    action: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      loading: true,
      fileList: [],
      importForm: {},
      importFormRules: {
        year: [ { required: true, message: '请选择年份', trigger: 'change' }],
        month: [ { required: true, message: '请选择月份', trigger: 'change' }],
        provinceId: [ { required: true, message: '请选择省区', trigger: 'change' }]
      },
      yearOptions: [],
      monthOptions: [],
      provinceOptions: []
    }
  },
  watch: {
    dialogVisible (val) {
      if (val) {
        this.$nextTick(() => {
          this.$refs.importForm.clearValidate()
        })
        this.loading = true
        this.provinceOptions = []
        this.importForm = {
          year: '',
          month: '',
          provinceName: '',
          provinceId: null
        }
        let currentDate = new Date()
        this.yearOptions = []
        this.monthOptions = []
        this.provinceOptions = []
        this.yearOptions.push({label: Number(currentDate.getFullYear())-1 + '年', data: Number(currentDate.getFullYear())-1})
        this.yearOptions.push({label: currentDate.getFullYear() + '年', data: Number(currentDate.getFullYear())})
        this.yearOptions.push({label: Number(currentDate.getFullYear())+1 + '年', data: Number(currentDate.getFullYear())+1})
        this.importForm.year = Number(currentDate.getFullYear())
        for(let i=0; i< 12; i++){
          this.monthOptions.push({label: i+1 + '月', data: i+1});
        }
        this.importForm.month = Number(currentDate.getMonth()) + 1
        this.initProvinceSelectData()
        this.importForm.provinceId = 7
        this.importForm.provinceName = '四川省'
      }
    }
  },
  methods: {
    getToken,
    // 初始省区下拉数据
    initProvinceSelectData(){
      let _this = this
      loadAreaDataApi({ parentId: 1, isUserArea : 1 }).then(res => {
        let resultData = res.data
        resultData.forEach(item => {
          this.provinceOptions.push({ label: item.name, data: item.id })
        })
        _this.loading = false
      })
    },
    // 选择省区回调
    changeProvinceFun(val){
      let selectItem = {}
      selectItem = this.provinceOptions.find(item => {
        return item.data === val
      })
      this.importForm.provinceName = selectItem ? selectItem.label : ''
    },
    // 模板导入前
    beforeTemplateImportUpload (file) {
      var testmsg = file.name.substring(file.name.lastIndexOf('.') + 1)
      const extension = testmsg === 'xls'
      const extension2 = testmsg === 'xlsx'
      if (!extension && !extension2) {
        this.$message({
          message: this.$t('messageTip.typeExcel'),
          type: 'warning'
        })
      }
      return extension || extension2
    },
    closeDialogImport () {
      this.$emit('update:dialogVisible', false)
      this.$refs.upload.clearFiles()
    },
    // eslint-disable-next-line no-unused-vars
    handleError (errObj, file, fileList) {
      this.$message.error('导入文件失败')
      this.loading = false
    },
    // eslint-disable-next-line no-unused-vars
    handleSuccess (response, file, fileList) {
      if (response.mark !== '200') {
        this.$refs.upload.clearFiles()
        this.$emit('showErr', response.message)
      } else {
        this.$message({ showClose: true, message: '导入文件成功', type: 'success' })
        this.$emit('reloadData')
        this.closeDialogImport()
      }
      this.loading = false
    },
    // eslint-disable-next-line no-unused-vars
    handleExceed (files, fileList) {
      this.$message.error('只能导入1个文件')
    },
    submitUpload () {
      this.$refs.importForm.validate(valid => {
        if (valid) {
          this.loading = true
          this.$refs.upload.submit()
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
</style>
